import React from 'react';
import moment from 'moment';

var NavSignedOut = React.createClass({

  getInitialState: function() {
    return { currentCount: '...' };
  },

  componentDidMount: function() {
    this.setState({currentCount: moment().to([2017, 6, 15], true)});
  },

  render: function() {
    return (
      <span className="navbar-text">
        Next Draft begins in about {this.state.currentCount}
      </span>
    );
  }

});

export default NavSignedOut;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavSignedOut.js